module.exports = __webpack_public_path__ + "img/order-message-icon.82c3a8dc.svg";